<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
  <input [type]="isPasswordVisible ? 'text' : 'password'" [value]="password" (input)="onPasswordInput($event.target)" matInput>
  <mat-icon (click)="isPasswordVisible = !isPasswordVisible">{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
</mat-form-field>
